module.exports = __webpack_public_path__ + "static/media/muscle.b47c498a.png";